import React, { Component } from "react";
import FlexView from "react-flexview";
import Button from "../../../../../modules/commons/Button";
import SimpleDate from "../../../../../modules/SimpleDate";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import { defaultTableChange } from "../../../../../modules/custom/customTable";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import M from "moment";
import * as R from "ramda";
import { extractFilter, getTableConfig } from "../config";
import SimpleInput from "../../../../../modules/SimpleInput";
import {
  contructQueryParam,
  fetchDataAsync,
  FormatCurrencyWithoutSymbol,
} from "../../../../../Services/Utils";
import CRMFollowUpFilter from "./crmFollowUpFilter";
import CRMFollowUpFollowUp from "./crmFollowUpFollowUp";
import SimpleAlert from "../../../../../modules/popup/SimpleAlert";
import CRMFollowUpModifying from "./crmFollowUpModifying";
import { ACTIVITY_TYPE, HttpStatus } from "../../../../common/Constants";
import {
  flattenFormGroupObject,
  removeNullFields,
} from "../../../../common/mapper";
import { formGroup } from "../../config";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import Api from "../../../../../Services/Api";
import moment from "moment";

class CRMFollowUpTab extends Component {
  actionButton = {
    name: "noProspek",
    label: "Aksi",
    options: {
      customBodyRender: (val) => {
        return (
          <FlexView style={{ justifyContent: "space-evenly", width: "100px" }}>
            <SimpleButton
              category="action_button"
              style={{ backgroundColor: "transparent" }}
              icon={
                <i
                  style={{ fontSize: 20, color: "red" }}
                  className="fa fa-eye"
                />
              }
              onClick={() =>
                this.handleModifyingVisibility(ACTIVITY_TYPE.VIEW, val)
              }
            />
            {(this.props.tab === "NON_FOLLOW_UP" ||
              this.props.tab === "PENDING" ||
              this.props.tab === "ONGOING") && (
              <SimpleButton
                category="action_button"
                style={{ backgroundColor: "transparent" }}
                icon={
                  <i
                    style={{ fontSize: 20, color: "red" }}
                    className="fa fa-person-booth"
                  />
                }
                onClick={() => this.handleFollowUpVisible(val)}
              />
            )}
            {(this.props.tab === "PENDING" || this.props.tab === "ONGOING") && (
              <SimpleButton
                category="action_button"
                style={{ backgroundColor: "transparent" }}
                icon={
                  <i
                    style={{ fontSize: 20, color: "red" }}
                    className="fa fa-trash"
                  />
                }
                onClick={() =>
                  this.handleModifyingVisibility(ACTIVITY_TYPE.DELETE, val)
                }
              />
            )}
          </FlexView>
        );
      },
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      filterVisible: false,
      historyVisible: false,
      followUpVisible: false,
      modifyingVisible: false,
      fuAlertVisible: false,
      fuConfirm: false,
      fuErrorVisible: false,
      fuDeleteVisible: false,
      deleteMessage: null,
      fuData: null,
      followUpId: null,
      errorProspekNo: null,
      deleteId: "",
      submittedFilter: {},
      tableConfig: [],
      dataTable: [],
      hobbyRaw: [],
      interestRaw: [],
      search: {
        kodeCabang: {},
        status: this.props.tab,
        tanggalProspek: {
          tanggalAwal: M(Date.now()).format("DD-MM-YYYY"),
          tanggalAkhir: M(Date.now()).format("DD-MM-YYYY"),
        },
      },
      pagination: {
        page: 1,
        limit: 5,
        totalData: 0,
      },
      skipNextPaginationFetch: false,
      alertInfo: {
        visible: false,
        title: null,
        content: null,
      },
    };
  }

  async componentDidMount() {
    await this.setState((prevValue) => ({
      ...prevValue,
      tableConfig: [...getTableConfig(this.props.tab), this.actionButton],
      search: {
        ...prevValue.search,
        kodeCabang: this.props.state.kodeCabang,
      },
    }));
    this.props.triggerLoading();
    if (!R.isEmpty(this.props.kodeCabang)) {
      await this.fetchData();
    }
    await this.fetchBizpar();
    this.props.triggerLoading();
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.state.search.kodeCabang.value !== this.props.state.kodeCabang.value
    ) {
      this.props.triggerLoading();
      // this.handleRefreshPagination();
      this.setState({ skipNextPaginationFetch: true });
      await this.handleRefresh();
      await this.fetchData();
      this.props.triggerLoading();
    }
    if (
      (prevState.pagination.page !== this.state.pagination.page ||
        prevState.pagination.limit !== this.state.pagination.limit) &&
      !this.state.skipNextPaginationFetch
    ) {
      this.props.triggerLoading();
      await this.fetchData(
        this.state.submittedFilterData,
        this.state.pagination.page,
        this.state.pagination.limit,
      );
      this.props.triggerLoading();
    }
    if (this.state.skipNextPaginationFetch) {
      this.setState({ skipNextPaginationFetch: false });
    }
  }

  handleRefresh = async () => {
    this.setState((prevValue) => ({
      ...prevValue,
      search: {
        ...prevValue.search,
        kodeCabang: this.props.state.kodeCabang,
        tanggalProspek: {
          tanggalAwal: M(Date.now()).format("DD-MM-YYYY"),
          tanggalAkhir: M(Date.now()).format("DD-MM-YYYY"),
        },
      },
    }));
  };

  handleRefreshPagination = () => {
    this.setState((prevState) => ({
      ...prevState,
      pagination: {
        totalData: 1,
        limit: 5,
        page: 1,
      },
    }));
  };

  fetchBizpar = async () => {
    this.props.triggerLoading();
    const menuName = "CRM - Follow Up Prospect";
    const responses = await Promise.all([
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam,
        setError: this.props.setError,
        menuName: menuName,
        args: { paramFilters: { bizparCategory: "HOBBY_TYPE" } },
      }),
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam,
        setError: this.props.setError,
        menuName: menuName,
        args: { paramFilters: { bizparCategory: "INTEREST_TYPE" } },
      }),
    ]);

    if (responses[0].ok && !R.isEmpty(responses[0].data.data)) {
      this.setState((prevValue) => ({
        ...prevValue,
        hobbyRaw: responses[0].data.data,
      }));
    }
    if (responses[1].ok && !R.isEmpty(responses[1].data.data)) {
      this.setState((prevValue) => ({
        ...prevValue,
        interestRaw: responses[1].data.data,
      }));
    }
    this.props.triggerLoading();
  };

  fetchData = async (filter) => {
    let request = !R.isNil(filter)
      ? {
          ...filter,
          tanggalProspek: removeNullFields(filter?.tanggalProspek || {}),
          fuDate: removeNullFields(filter?.fuDate || {}),
          appointmentDate: removeNullFields(filter?.appointmentDate || {}),
          kodeCabang: this.props.kodeCabang.value,
          idProvince: filter?.province?.value,
          idKabkot: filter?.kabkot?.value,
          kecamatan: filter?.kecamatan?.value,
          kelurahan: filter?.kelurahan?.value,
          kodePos: filter?.kodePos?.value,
          status: this.props.tab,
        }
      : !R.isEmpty(this.state.submittedFilter)
        ? {
            ...this.state.submittedFilter,
            tanggalProspek: removeNullFields(
              this.state.submittedFilter?.tanggalProspek,
            ),
            fuDate: removeNullFields(this.state.submittedFilter?.fuDate),
            appointmentDate: removeNullFields(
              this.state.submittedFilter?.appointmentDate,
            ),
            kodeCabang: this.props.kodeCabang.value,
            idProvince: this.state.submittedFilter?.idProvince?.value,
            idKabkot: this.state.submittedFilter?.idKabkot?.value,
            kecamatan: this.state.submittedFilter?.kecamatan?.value,
            kelurahan: this.state.submittedFilter?.kelurahan?.value,
            kodePos: this.state.submittedFilter?.kodePos?.value,
            status: this.props.tab,
          }
        : {
            ...this.state.search,
            kodeCabang: this.props.kodeCabang.value,
          };

    this.setState((prevValue) => ({
      ...prevValue,
      submittedFilter:
        filter !== undefined ? filter : this.state.submittedFilter,
    }));
    request = extractFilter(request);
    try {
      let res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION").findAllDataFU,
        setError: this.props.setError,
        menuName: "CRM - Follow Up Prospect",
        args: {
          ...removeNullFields(request),
          limit: this.state.pagination.limit,
          page: this.state.pagination.page,
          userLogin: this.props.auth?.user?.idUser,
          adminLine: this.props.user?.user.administrationLine,
        },
      });
      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataTable: res.data.data,
          pagination: {
            ...prevValue.pagination,
            totalData: res.data.totalData,
          },
        }));
      }
    } catch (e) {
      console.log("error", e);
    }
  };

  handlePeriodeChange = (name, value) => {
    if (
      R.equals(name, "tanggalAkhir") &&
      M(value, "DD-MM-YYYY").isBefore(
        M(this.state.search.tanggalProspek.tanggalAwal, "DD-MM-YYYY"),
      )
    ) {
      this.setState((prevValue) => ({
        ...prevValue,
        search: {
          ...prevValue.search,
          tanggalProspek: {
            tanggalAwal: M(value).format("DD-MM-YYYY"),
            tanggalAkhir: M(value).format("DD-MM-YYYY"),
          },
        },
      }));
      return;
    }

    this.setState((prevValue) => ({
      ...prevValue,
      search: {
        ...prevValue.search,
        tanggalProspek: {
          ...prevValue.search.tanggalProspek,
          [name]: M(value).format("DD-MM-YYYY"),
        },
      },
    }));
  };

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        page: 1,
        totalData: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  handleFollowUpVisible = (val) => {
    this.setState((prevValue) => ({
      ...prevValue,
      followUpId: val,
      followUpVisible: !prevValue.followUpVisible,
    }));
  };

  handleModifyingVisibility = async (at, val) => {
    await this.props.handleModifyingVisibility(at, val);
  };

  handleFilterVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterVisible: !prevValue.filterVisible,
    }));
  };

  handleSubmitFilter = (filter, resetFilter) => {
    // this.handleRefreshPagination();
    this.handleFilterVisibility();
    this.setState(
      (prevState) => ({
        submittedFilter: filter,
        search: {
          ...prevState.search,
          tanggalProspek: {
            tanggalAwal: resetFilter
              ? M(Date.now()).format("DD-MM-YYYY")
              : null,
            tanggalAkhir: resetFilter
              ? M(Date.now()).format("DD-MM-YYYY")
              : null,
          },
        },
        pagination: {
          ...prevState.pagination,
          page: 1,
          totalData: 0
        },
        skipNextPaginationFetch: true,
      }),
      async () => {
        this.props.triggerLoading();
        await this.fetchData(resetFilter ? null : filter);
        this.props.triggerLoading();
      },
    );
  };

  handleSubmitFollowUp = (data) => {
    this.setState((prevValue) => ({
      ...prevValue,
      fuAlertVisible: !prevValue.fuAlertVisible,
      fuData: data,
    }));
  };

  handleAlertInfoVisibility = (title = null, content = null) => {
    this.setState((prevValue) => ({
      ...prevValue,
      alertInfo: {
        visible: !prevValue.alertInfo.visible,
        title: title,
        content: content,
      },
    }));
  };

  handleSetState = (callback) => {
    this.setState(callback);
  };

  handleShowAlert = (id) => {
    console.log("clicked", id);
    if (id) {
      this.setState((prevValue) => ({ ...prevValue, deleteId: id }));
    } else {
      this.setState((prevValue) => ({
        ...prevValue,
        deleteId: "",
        loading: false,
      }));
    }
  };

  checkFUProspect = async (controls) => {
    this.props.triggerLoading();
    const request = {
      nik: controls.nik?.value,
      category: controls.category?.value?.value,
    };
    if (controls.prospectId?.value) {
      request.prospectId = controls.prospectId?.value;
    }
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").checkFUProspect,
      menuName: "CRM - Follow Up Prospek",
      setError: this.props.setError,
      args: request,
    });
    if (res.ok) {
      if (res.data.data.status) {
        this.setState((prevValue) => ({
          ...prevValue,
          fuErrorVisible: !prevValue.fuErrorVisible,
          errorProspekNo: res.data.data.prospectId,
        }));
      } else {
        this.submitProspect(flattenFormGroupObject(controls));
      }
    }
    this.props.triggerLoading();
  };

  submitProspect = async (controls) => {
    this.props.triggerLoading();

    try {
      let hobbyList = controls?.hobby?.map((item) => item.value);
      let interestList = controls?.interest?.map((item) => item.value);

      const request = {
        prospectId: null,
        kodeCabang: this.props.kodeCabang.value,
        dataProspectCustomer: {
          dataCustomer: {
            customerId: null,
            name: controls?.name,
            nik: controls?.nik,
            address: controls?.address,
            provinceId: controls?.provinceId?.value,
            kabkotId: controls?.kabkotId?.value,
            kecamatanId: controls?.kecamatanId?.value,
            kelurahanId: controls?.kelurahanId?.value,
            job1: controls?.job1?.value,
            job2: controls?.job2?.value,
            religion: controls?.religion?.value,
            hpNumber1: controls?.hpNumber1,
            hpNumber2: controls?.hpNumber2,
            gender: controls?.gender?.value,
            email: controls?.email,
            instagram: controls?.instagram,
            facebook: controls?.facebook,
            linkedin: controls?.linkedin,
            x: controls?.twitter,
            tiktok: controls?.tiktok,
            characterDisc: controls?.discCategory?.value,
            hobby: this.state.hobbyRaw?.filter((item) =>
              hobbyList?.includes(item.key),
            ),
            interest: this.state.interestRaw?.filter((item) =>
              interestList?.includes(item.key),
            ),
            specialNotes: controls?.specialNotes,
            photoProfilBase64: controls?.photoCustomerUrl,
            memberLevel: controls?.memberLevel?.value || null,
            loyaltyLevel: controls?.loyaltyLevel?.value || null,
          },
          dataProspect: {
            categoryProspect: controls.category?.value,
            prospectSource: controls.source?.value,
            idUserProspectOwner: this.props.auth?.user?.idUser,
            prospectType: !R.isNil(controls.type)
              ? controls.type?.value
              : "NEW",
            prospectDate: !R.isNil(controls.prospectDate)
              ? controls.prospectDate
              : M(new Date()).format("DD-MM-YYYY"),
          },
        },
        dataFollowUpProspect: {
          status: "ONGOING",
          followUpDate: moment().format("DD-MM-YYYY"),
        },
      };

      let res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION").saveFUProspect,
        menuName: "CRM - Follow Up Prospek",
        setError: this.props.setError,
        args: request,
      });

      if (res?.ok) {
        await this.fetchData(this.state.submittedFilter);
        this.props.onSetState((prev) => ({
          ...prev,
          modifyingVisible: false,
        }));
      }
    } catch (error) {
      console.log("submitProspect error:", error);
    } finally {
      this.props.triggerLoading();
    }
  };

  handleFUAlert = async (id) => {
    this.props.triggerLoading();

    try {
      if (id) {
        let dataProspect = {};
        let dataCustomer = {};

        let resDetail = await fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailFU,
          setError: this.props.setError,
          menuName: "CRM - Follow Up Prospect",
          args: id,
        });

        if (resDetail?.ok) {
          let data = resDetail.data.data;

          dataCustomer = {
            nik: data.prospect.nik,
            name: data.prospect.name,
          };

          const userId = localStorage.getItem("userId");

          dataProspect = {
            idUserLastSeller: data.prospect.userLastSeller?.id
              ? userId
              : null,
            idLastUpdateByUser: userId,
          };
        }

        let res = await fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_TRANSACTION").saveFUProspect,
          setError: this.props.setError,
          menuName: "CRM - Follow Up Prospek",
          args: {
            prospectId: id,
            kodeCabang: this.props.kodeCabang.value,
            dataFollowUpProspect: { ...this.state.fuData },
            dataProspectCustomer: { dataProspect, dataCustomer },
          },
        });

        if (res?.ok && res?.data?.status === HttpStatus.SUCCESS) {
          await this.fetchData(this.state.submittedFilter);
          this.setState((prev) => ({
            ...prev,
            followUpVisible: false,
            fuAlertVisible: false,
            fuData: null,
          }));
        }

        const message = res?.data?.message || "";
        if (message?.startsWith("Pengajuan tidak dapat dilakukan ")) {
          this.handleAlertInfoVisibility(
            "Informasi",
            message || "Terjadi Kesalahan pada server"
          );
        }

      } else {
        this.setState((prev) => ({
          ...prev,
          fuAlertVisible: false,
          followUpVisible: false,
        }));
      }
    } catch (error) {
      console.log("handleFUAlert error:", error);
    } finally {
      this.props.triggerLoading();
    }
  };


  handleDeleteProspek = async () => {
    this.props.triggerLoading();

    try {
      let res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION").deleteFollowUpProspect,
        menuName: "CRM - Follow Up Prospek",
        setError: this.props.setError,
        args: this.state.deleteId,
      });

      if (res?.ok && res?.data?.status === HttpStatus.SUCCESS) {
        const isLastItemOnPage =
          this.state.dataTable?.length === 1 &&
          this.state.pagination.page > 1;

        if (isLastItemOnPage) {
          this.setState(
            (prev) => ({
              pagination: {
                ...prev.pagination,
                page: prev.pagination.page - 1,
              },
            }),
            async () => {
              await this.fetchData(this.state.submittedFilter);
            }
          );
        } else {
          await this.fetchData(this.state.submittedFilter);
        }

        this.setState({
          deleteId: "",
        });

        this.props.onSetState((prevValue) => ({
          ...prevValue,
          modifyingVisible: false,
        }));

        this.handleFUDeleteVisibility(res.data.data);
      }
    } catch (error) {
      console.log("handleDeleteProspek error:", error);
    } finally {
      this.props.triggerLoading();
    }
  };


  handleFUErrorVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      fuErrorVisible: !prevValue.fuErrorVisible,
      errorProspekNo: null,
    }));
  };

  handleSearch = async () => {
    this.props.triggerLoading();
    await this.fetchData();
    this.props.triggerLoading();
  };

  handleFUDeleteVisibility = (deleteMessage) => {
    this.setState((prevValue) => ({
      ...prevValue,
      fuDeleteVisible: !prevValue.fuDeleteVisible,
      deleteMessage,
    }));
  };

  render() {
    const { fuAlertVisible, fuData, followUpId } = this.state;

    const alertContent =
      fuData?.status?.toLowerCase() === "drop" ||
      fuData?.status?.toLowerCase() === "death" ? (
        <div>
          <p>
            Follow Up dengan No prospek <b>{followUpId}</b> akan ditambahkan dan
            membutuhkan <b>approval.</b>
          </p>
          <p>Apakah anda yakin?</p>
        </div>
      ) : (
        <div>
          <p>Follow Up akan ditambahkan</p>
          <p>Apakah anda yakin?</p>
        </div>
      );

    return (
      <>
        <FlexView
          style={{ justifyContent: "space-between" }}
          vAlignContent="center"
          className="margin-top-5px"
        >
          <FlexView vAlignContent="center" style={{ gap: "10px" }}>
            <p className="margin-bottom-20px">Periode: </p>
            <SimpleDate
              id="select_prospek_date_period_from"
              name="tanggalAwal"
              nextdate
              date={this.state.search.tanggalProspek.tanggalAwal}
              maxDate={this.state.search.tanggalProspek.tanggalAkhir}
              onChange={(value) =>
                this.handlePeriodeChange("tanggalAwal", value)
              }
            />
            <span className="margin-bottom-20px">s/d</span>
            <SimpleDate
              id="select_prospek_date_period_to"
              name="tanggalAkhir"
              nextdate
              date={this.state.search.tanggalProspek.tanggalAkhir}
              minDate={this.state.search.tanggalProspek.tanggalAwal}
              onChange={(value) =>
                this.handlePeriodeChange("tanggalAkhir", value)
              }
            />
            <SimpleButton
              className="margin-bottom-20px"
              onClick={this.handleSearch}
            >
              Cari
            </SimpleButton>
          </FlexView>
          <Button
            type="button"
            onClick={this.handleFilterVisibility}
            className="btn background-red margin-bottom-20px"
          >
            <span>
              <i className="fa fa-qrcode"></i>
            </span>
          </Button>
        </FlexView>
        <SimpleDataTable
          data={this.state.dataTable}
          columns={this.state.tableConfig}
          toCount={this.state.pagination.totalData}
          rowsPerPage={this.state.pagination.limit}
          page={this.state.pagination.page - 1}
          options={defaultTableChange(
            this.handleChangePage,
            this.handleRowsPerPage,
          )}
        />
        <FlexView style={{ justifyContent: "end" }}>
          <SimpleInput
            box="number"
            name="totalData"
            label={`Total Data ${this.props.title}`}
            value={FormatCurrencyWithoutSymbol({
              number: this.state.pagination.totalData || 0,
            })}
          />
        </FlexView>
        {this.state.filterVisible && (
          <CRMFollowUpFilter
            search={this.state.submittedFilter}
            visible={this.state.filterVisible}
            onClickClose={this.handleFilterVisibility}
            onSubmit={this.handleSubmitFilter}
            // onSetState={this.handleSetState}
          />
        )}
        {this.props.state.modifyingVisible && (
          <CRMFollowUpModifying
            {...this.props}
            formGroup={formGroup}
            initialValues={this.props.state.selectedData}
            visible={this.props.state.modifyingVisible}
            onClickClose={this.handleModifyingVisibility}
            onRefresh={() => this.handleRefresh()}
            onDeleteProspect={this.handleShowAlert}
            onSubmit={this.checkFUProspect}
            activityType={this.props.state.activityType}
            title={
              this.props.state.activityType === ACTIVITY_TYPE.VIEW
                ? "History Follow Up"
                : this.props.state.activityType === ACTIVITY_TYPE.CREATE
                  ? "Create Prospek"
                  : ""
            }
          />
        )}
        {this.state.followUpVisible && (
          <SimpleModal
            title="FollowUp"
            visible={this.state.followUpVisible}
            onClickClose={() => this.handleFollowUpVisible()}
            styles={{ width: "50%" }}
            content={
              <ModalContainer>
                <CRMFollowUpFollowUp
                  {...this.props}
                  onSubmit={this.handleSubmitFollowUp}
                />
              </ModalContainer>
            }
          />
        )}
        {this.state.deleteId !== "" && (
          <SimpleAlert
            styles={{ width: "20%" }}
            visible={this.state.deleteId !== ""}
            onClickClose={() => this.handleShowAlert()}
            content={
              <div>
                <p>Prospek akan dihapus. Apakah</p>
                <p>anda yakin?</p>
              </div>
            }
            additionalButtons={
              <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                <SimpleButton secondary onClick={() => this.handleShowAlert()}>
                  Batal
                </SimpleButton>
                <SimpleButton onClick={this.handleDeleteProspek}>
                  Iya
                </SimpleButton>
              </FlexView>
            }
          />
        )}
        {this.state.fuAlertVisible && (
          <SimpleAlert
            styles={{ width: "20%" }}
            visible={this.state.fuAlertVisible}
            onClickClose={() => this.handleFUAlert()}
            content={alertContent}
            // content={
            //   <div>
            //     <p>Follow Up akan ditambahkan</p>
            //     <p>Apakah anda yakin?</p>
            //   </div>
            // }
            additionalButtons={
              <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                <SimpleButton secondary onClick={() => this.handleFUAlert()}>
                  Batal
                </SimpleButton>
                <SimpleButton
                  onClick={() => this.handleFUAlert(this.state.followUpId)}
                >
                  Iya
                </SimpleButton>
              </FlexView>
            }
          />
        )}
        {this.state.fuErrorVisible && (
          <SimpleAlert
            styles={{ width: "20%" }}
            visible={this.state.fuErrorVisible}
            onClickClose={() => this.handleFUErrorVisibility()}
            content={
              <div>
                <p>Data Customer sudah memiliki prospek dengan</p>
                <p>{`nomor Prospek : ${this.state.errorProspekNo}`}</p>
                <p>Penambahan prospek diabaikan</p>
              </div>
            }
            additionalButtons={
              <FlexView style={{ justifyContent: "end" }}>
                <SimpleButton onClick={this.handleFUErrorVisibility}>
                  OK
                </SimpleButton>
              </FlexView>
            }
          />
        )}
        {this.state.fuDeleteVisible && (
          <SimpleAlert
            styles={{ width: "20%" }}
            visible={this.state.fuDeleteVisible}
            onClickClose={() => this.handleFUDeleteVisibility(null)}
            content={
              <div>
                <p>{this.state.deleteMessage}</p>
              </div>
            }
            additionalButtons={
              <FlexView style={{ justifyContent: "end" }}>
                <SimpleButton
                  onClick={() => this.handleFUDeleteVisibility(null)}
                >
                  OK
                </SimpleButton>
              </FlexView>
            }
          />
        )}

        {this.state.alertInfo?.visible && (
          <SimpleAlert
            title={this.state.alertInfo?.title}
            content={<p>{this.state.alertInfo?.content}</p>}
            visible={this.state.alertInfo?.visible}
            onClickClose={() => this.handleAlertInfoVisibility()}
            additionalButtons={
              <SimpleButton
                type="button"
                text="OK"
                onClick={() => this.handleAlertInfoVisibility()}
              />
            }
          />
        )}
      </>
    );
  }
}

export default CRMFollowUpTab;
